module.exports = __webpack_public_path__ + "static/img/banner.d6feeb78.png";